<style lang="less" scoped>

/deep/ .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-modal{
        top: -15%;
    }
   
}
/deep/ .ivu-modal-mask{
    z-index: 1016 !important;
}
/deep/ .ivu-modal-wrap{
    z-index: 1016 !important;
}
</style>

<template>
<div>
    <Modal
        class-name="vertical-center-modal"
        :value="showModel"
        :title="$t('deviceManage.joinHome')"
        :footer-hide="true"
        :mask-closable="false"
        @on-cancel="cancel"
        @on-visible-change="openOrClose"  :styles="{'min-width':'700px'}">
        
        <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80">

            <FormItem :label="$t('userManage.associate.criteria')" prop="searchType" class="ivu-form-item-required"
                style="width: 560px">
                <RadioGroup v-model="formData.searchType">
                    <Radio :label="item.id" v-for="(item) in searchTypeList" :key='item.id'>
                        <span>{{ item.name }}</span>
                    </Radio>
                </RadioGroup>
            </FormItem>

            <FormItem :label="$t('userManage.associate.userName')" prop="userId"  style="width: 500px">
                <SearchSelect
                   ref="userRef" 
                   refName="userRef" 
                   :url="searchUserUrl"
                   :labelName='searchTypeObj[formData.searchType]' 
                   :selectUrlQuery="selectUrlQuery" 
                   isMultiple='2'  
                   valName='userId' 
                   listName="userList"
                   :labelNameNew="searchTypeObj[formData.searchType]!='id'?'id':''"
                   :keyword="searchTypeObj[formData.searchType]" 
                   :labelInValue="true" 
                   :placeholderText="$t('selectPlaceholder')"  
                   @setSelected="setSelectValPage($event,'userId')"></SearchSelect>
            </FormItem>


            <FormItem>
                <Button :loading="disabled"  type="primary" @click="subData('formData')" style="margin-right:20px">{{$t('confirm')}}</Button>
                <Button :disabled="disabled" @click="cancel">{{$t('cancel')}}</Button>
            </FormItem>
        </Form>

    </Modal>
</div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import SearchSelect from '@/views/common/selectListRecycle.vue';
import { mapState } from 'vuex'

    export default {
        props: {
            showModel: Boolean,
            fn:Function,
            editFormData:Object
        },
        name: "SModel3",
        components: {
            SearchSelect
        },
        data() {
            return {   
                searchUserUrl:this.config.urlArray.getDealerAdminMember,
                searchTypeList:[
                    {id:'userAccount',name:this.$t("userManage.titleName.Account")},
                    {id:'phoneNumber',name:this.$t("userManage.phoneNumber")},
                    {id:'emailAddress',name:this.$t("userManage.emailAddress")}
                ],
                searchTypeObj:{
                    userAccount:'id',
                    phoneNumber:'phoneNumber',
                    emailAddress:'emailAddress',
                },
                selectUrlQuery:{
                    emailAddress:'',
                    phoneNumber:'',
                    userAccount:'',
                },
                disabled: false,//禁用确定按钮
                title: '',//弹框标题
                formData: {//表单数据
                    userId: '888e0238-a76b-4e86-9ace-05cfabec935a',
                    searchType:'userAccount',
                },
            }
        },
        watch:{
            showModel(val){
                if(val){
                    
                }
            },
        },
        computed:{
             ...mapState(['selectId']),
            ruleCustom(){//验证
                return {
                     userId: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ]
                }   
            }
        },
        created(){
           
        },
        methods: {
            openOrClose(value) {
                if(value === true) {    
                    this.$nextTick(()=>{//select赋值，图片赋值
                        this.$refs.userRef.getData()
                    });   
                }else{
                    this.$refs.userRef.clearVal();
                    this.cancel();//重置表单
                }
            },
            setSelectValPage(e,key){
                 this.formData.userId = e.userId 
            },
            subData(name) {//提交表单
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.disabled = true;
                        this.axios.post(this.config.urlArray.applyJoinFamily,{userId:this.formData.userId,serialNumber:this.editFormData.serialNumber}).then((result) => {
                            
                            common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                                this.fn()
                                this.cancel()
                            },()=>{
                                this.disabled = false; 
                            })
                            
                        }).catch((err) => {
                            // common.msg('error',this.$t('failed'),()=>{this.disabled = false;})
                            this.disabled = false;
                        });
                        
                    }
                })
            },
            cancel() {//对话框关闭
                this.resetForm()
                this.$emit('update:showModel',false);
            },
            resetForm() {//重置表单
                this.$refs.formData.resetFields();//重置表单
                this.disabled = false;//恢复提交按钮为激活状态
            }
        }
    }
</script>
